// extracted by mini-css-extract-plugin
export default {"bigBlock":"bigBlock__YSG9R","uppercase":"uppercase__HI-t9"};